import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	componentHeader: {
		id: 'project-pages-project-directories.components.view.compass-table.component-head',
		defaultMessage: 'Component',
		description: 'Header content for Components table Component column.',
	},
	ownerTeamHeader: {
		id: 'project-pages-project-directories.components.view.compass-table.owner-team-head',
		defaultMessage: 'Owner team',
		description: 'Header content for Components table Owner team column.',
	},
	repositoryHeader: {
		id: 'project-pages-project-directories.components.view.compass-table.repository-head',
		defaultMessage: 'Repository',
		description: 'Header content for Components table Repository column.',
	},
	dependenciesHeader: {
		id: 'project-pages-project-directories.components.view.compass-table.dependencies-head',
		defaultMessage: 'Dependencies',
		description: 'Header content for Components table Dependencies column.',
	},
	scorecardHeader: {
		id: 'project-pages-project-directories.components.view.compass-table.scorecard-head',
		defaultMessage: 'Scorecards',
		description: 'Header content for Components table Scorecard column.',
	},
	issuesHeader: {
		id: 'project-pages-project-directories.components.view.compass-table.issues-head',
		defaultMessage: 'Issues',
		description: 'Header content for Components table Issues column.',
	},
	componentCount: {
		id: 'project-pages-project-directories.components.view.compass-table.component-count',
		defaultMessage:
			'{componentCount, plural, one {# component} other {# components}} linked to project',
		description: 'Header content for Components table Issues column.',
	},
	componentInfo: {
		id: 'project-pages-project-directories.components.view.compass-table.component-info',
		defaultMessage:
			'Compass components appear here when they’re added to an issue’s <bold>Components</bold> field. <link>Learn more</link>',
		description: 'Header content for Components table Issues column.',
	},
	issuesHeaderIssueTermRefresh: {
		id: 'project-pages-project-directories.components.view.compass-table.issues-head-issue-term-refresh',
		defaultMessage: 'Work items',
		description: 'Header content for Components table Issues column.',
	},
	componentInfoIssueTermRefresh: {
		id: 'project-pages-project-directories.components.view.compass-table.component-info-issue-term-refresh',
		defaultMessage:
			'Compass components appear here when they’re added to the <bold>Components</bold> field in a work item. <link>Find out more</link>',
		description: 'Header content for Components table Issues column.',
	},
});
